import type { ReactNode } from 'react';
import { CardContent, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { MessageKey } from '../i18n';
import { DashboardPanel } from './DashboardPanel';
import { TranslatedText } from './TranslatedText';

interface ActionCardProps {
  title: MessageKey;
  subtitle?: MessageKey;
  children: ReactNode;
}

const StyledCard = styled(DashboardPanel)({
  overflow: 'hidden',
});

const PanelContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2.25),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3),
  },
}));

const HeaderStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(0.75),
}));

const BodyStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

const CardTitle = styled(TranslatedText)({
  fontSize: '1.35rem',
});

export function ActionCard({ title, subtitle, children }: ActionCardProps) {
  return (
    <StyledCard>
      <PanelContent>
        <HeaderStack>
          <CardTitle messageKey={title} variant="h2" />
          {subtitle ? (
            <TranslatedText
              messageKey={subtitle}
              variant="body2"
              color="text.secondary"
            />
          ) : null}
        </HeaderStack>
        <BodyStack>{children}</BodyStack>
      </PanelContent>
    </StyledCard>
  );
}
